import type { ICacheItemConfig, ICommonCacheKeys } from "@aspen/model";
import { aspenApi as api } from "./api";
import { EN, ZH_CN } from "@aspen/libs";

/**
 * @description: 需要缓存数据的接口，有新的需要缓存数据的接口，,需要在这里配置key(key名尽量和reux key保持一致)
 *  api 接口地址
 *  param 接口参数，不需要传参数时，将参数设置为undefined
 *  language 接口语言, 不区分语言时，设置为 "", 或者不设置
 */
export const DATA_CACHES_KEYS: Record<ICommonCacheKeys, ICacheItemConfig<any>> = {
  // 钱包数据
  walletInfo: {
    api: api.wallet.walletInfo, //"wallet/walletInfo",
    param: { showRevenue: true },
    language: "",
    options: {
      onError: () => {
        // Handle error
      },
    },
  },
  // 首次需要的资产打点数据
  assetsLineData: {
    api: api.assets.static, //"asset/statics",
    param: {
      type: 0, //day 0, week 1, month 2, year 3 目前默认只显示0
      offset: 0,
      limit: 30,
    },
    language: "",
  },
  yieldFlexibleProducts: {
    api: api.savings.flexible.products,
    param: { limit: 100 },
    language: [ZH_CN, EN],
  },
};

// 缓存传递的key值
export type ICachekeys = keyof typeof DATA_CACHES_KEYS | undefined;
